export default {
  GET_ALLIANZ_FUND_QUERY: Symbol.for('GET_ALLIANZ_FUND_QUERY'),
  ALLIANZ_FUND_REPOSITORY: Symbol.for('ALLIANZ_FUND_REPOSITORY'),
};
